module.exports = __webpack_public_path__ + "static/media/desmosandgeogebra.9060fa37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desmosandgeogebra.png
// module id = 1728
// module chunks = 2